import type Cookie from '@gifsa/cookie-utils'
import { LANG } from '@gifsa/language-utils/lang'

export default defineNuxtPlugin({
  name: 'language',
  dependsOn: ['cookie'],
  setup({ $cookie }) {
    try {
      const route = useRoute()
      const metaLang = route.meta.lang
      const paramLang = Array.isArray(route.params.lang) ? route.params.lang[0] : route.params.lang

      const cookieLang = ($cookie as Ref<Cookie>).value.getLang()
      const lang = metaLang || paramLang || cookieLang

      if (!lang || !Object.keys(LANG).includes(lang)) {
        // Probably invalid route, it will be handled by the router
        return { provide: { lang: 'en' } }
      }
      return { provide: { lang } }
    } catch (e) {
      useLogger('plugin:language').error(e)
      throw e
    }
  },
})
